import React from 'react';

import NavigationWidgets from './navigationWidgets';
import { createMenuItems } from './navigation';

/**
 * To not only show the first entries of the menu,
 * this function displays the child-items of each parent, if given.
 *
 * @param {json} { menuData } data of children-objects provided by MenuItem
 */
export function MenuItemChildren({ menuData, activePath, widgets }) {
  let menuItems = createMenuItems(menuData, activePath, widgets);

  if (!menuItems.length) {
    return null;
  }

  if (widgets.length) {
    return (
      <ul>
        {menuItems}
        <li />
        <NavigationWidgets widgets={widgets} />
      </ul>
    );
  }

  return <ul>{menuItems}</ul>;
}

MenuItemChildren.propTypes = {
  menuData: React.PropTypes.array,
  activePath: React.PropTypes.array,
  widgets: React.PropTypes.array
};



// WEBPACK FOOTER //
// ./components/MenuItemChildren.js